import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { IActionType, IAxiosResponse } from '../root.types'
import { ReportTypes } from './types'
import reportService from '../../../services/report'
import {
    loadActiveSearchResponseFailure,
    loadActiveSearchResponseSuccess,
    loadActiveSearchSummaryFailure,
    loadActiveSearchSummarySuccess,
    loadReportFailure,
    loadReportSuccess
} from './actions'


export function* loadReport(action: IActionType<any>) {
    const { filter } = action.payload

    try {
        const response: IAxiosResponse<any> = yield apply(
            reportService,
            reportService.getAll,
            [filter]
        )

        yield put<any>(loadReportSuccess(response.data))
    } catch (e) {
        yield put<any>(loadReportFailure())
    }

}
export function* loadActiveSearchSummary(action: IActionType<any>) {
    const { filter } = action.payload

    try {
        const response: IAxiosResponse<any> = yield apply(
            reportService,
            reportService.getActiveSearchSummary,
            [filter]
        )

        yield put<any>(loadActiveSearchSummarySuccess(response.data))
    } catch (e) {
        yield put<any>(loadActiveSearchSummaryFailure())
    }

}
export function* loadActiveSearchResponse(action: IActionType<any>) {
    const { filter } = action.payload

    try {
        const response: IAxiosResponse<any> = yield apply(
            reportService,
            reportService.getActiveSearchResponse,
            [filter]
        )

        yield put<any>(loadActiveSearchResponseSuccess(response.data))
    } catch (e) {
        yield put<any>(loadActiveSearchResponseFailure())
    }

}
export default function* reportSaga() {
    return yield all([
        takeLatest(ReportTypes.LOAD_REPORT_REQUEST, loadReport),
        takeLatest(ReportTypes.LOAD_ACTIVE_SEARCH_RESPONSE_REQUEST, loadActiveSearchResponse),
        takeLatest(ReportTypes.LOAD_ACTIVE_SEARCH_SUMMARY_REQUEST, loadActiveSearchSummary),
    ])
}